import { FontWeights, IToggleProps, Toggle } from "@fluentui/react";
import React, { useEffect, PropsWithChildren } from "react";

export const ToggleContent = ({
  children,
  checked,
  defaultChecked = false,
  onChange,
  containerStyle = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  childrenContainerStyle = {
    width: "100%",
  },
  styles = {
    label: {
      fontWeight: FontWeights.regular,
      display: "block",
      flexGrow: 1,
      margin: 0,
      fontSize: "1rem !important",
      lineHeight: "1.25rem !important",
      color: "inherit",
    },
    root: {
      display: "flex",
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      float: "none",
      paddingRight: "8px",
      color: "var(--color-blue)",
    },
  },
  ...toggleProps
}: Omit<PropsWithChildren<IToggleProps>, "inlineLabel"> & {
  containerStyle?: React.CSSProperties;
  childrenContainerStyle?: React.CSSProperties;
}) => {
  const [internalChecked, setInternalChecked] = React.useState<boolean>(checked ?? defaultChecked);
  useEffect(() => {
    setInternalChecked(checked ?? defaultChecked);
  }, [checked, defaultChecked]);

  return (
    <div style={containerStyle}>
      <Toggle
        inlineLabel
        styles={styles}
        checked={internalChecked}
        onChange={(event, checked) => {
          setInternalChecked(checked);
          onChange?.(event, checked);
        }}
        {...toggleProps}
      />
      {internalChecked && children && <div style={childrenContainerStyle}>{children}</div>}
    </div>
  );
};
